import React from "react";
import { Perspective, UIState } from "../../../App";
import PerspectivePanelItem from "./perspective-panel-item/PerspectivePanelItem";
import './PerspectivePanel.scoped.scss';

interface ComponentProps {
    didClickOnLearnMore: (perspective: Perspective) => void;
    presentModalContent: (content: JSX.Element) => void;
    didClickOnPerspective: (perspective: Perspective) => void;
    uiState: UIState;
    openedPerspective: Perspective;
}

class PerspectivePanel extends React.Component<ComponentProps, any> {
    shouldComponentUpdate(nextProps: ComponentProps, nextState: any) {
        if (this.props.uiState !== nextProps.uiState) {
            return true;
        }
        if (this.props.openedPerspective !== nextProps.openedPerspective) {
            return true;
        }
        return false;
    }

    render() {
        let uiStateClass = (this.props.uiState === UIState.PerspectivesOpened) ? "opened" : "";
        const listItems = Object.values(Perspective).map((perspective) => {
            return <PerspectivePanelItem key={perspective} perspective={perspective}
                isActive={perspective === this.props.openedPerspective && this.props.uiState === UIState.PerspectivesOpened}
                didClickOnLearnMore={this.props.didClickOnLearnMore}
                presentModalContent={this.props.presentModalContent}
                didClickOnPerspective={this.props.didClickOnPerspective}
            ></PerspectivePanelItem>
        });
        return (
            <>
                <div className={['capacity-panel-wrp perspective', uiStateClass].join(' ')}>
                    {listItems}
                </div>
            </>
        )
    }
}

export default PerspectivePanel;